import FormPanelButtonUpdateIndexesBase, {
    FormPanelButtonUpdateIndexesControlProps,
} from './FormPanelButtonUpdateIndexesBase';
import { FormPanelButtonProps } from 'components/common/form/index';
import useBundleTranslation from 'i18n';
import { MutableRefObject, ReactElement } from 'react';
import {
    getReIndexRequiredContent,
    getReIndexRequiredTitle,
} from 'components/common/form/layout/helper/ReIndexRequiredLine';
import { useConfigConstantValue } from 'hooks/useConfigConstant';

const RUNNING_STATUSES = ['initiating', 'running'];

export default function FormPanelButtonUpdateIndexes(
    props: FormPanelButtonProps<FormPanelButtonUpdateIndexesControlProps> & {
        confirmationPopupContent?: ReactElement;
        confirmationPopupTitle?: string;
        triggerRef?: MutableRefObject<any>;
        showProgress: boolean;
    },
) {
    const { t } = useBundleTranslation([props.button.translationNS ?? 'components/common/form/form']);
    const confVar: string = useConfigConstantValue('GLOBAL_SEARCH_DATA_ANALYZER_INDEX_TYPE');

    const showProgress = props.showProgress === undefined ? true : props.showProgress;

    return (
        <FormPanelButtonUpdateIndexesBase
            confirmationPopupContent={getReIndexRequiredContent(t, 'optimized', confVar)}
            confirmationPopupTitle={getReIndexRequiredTitle(t, 'optimized', confVar)}
            {...props}
            getInitialProgressStatus={(res) => showProgress && RUNNING_STATUSES.includes(res?.data?.index_status)}
            getProgressValue={(res) => {
                const status = res?.data?.index_status;
                if (status === 'initiating') return 0;
                if (status === 'running') return Number(res.data.index_progress ?? 0);
                if (status === 'inactive') return 100;
                return null;
            }}
        />
    );
}
